import React from 'react';
import FordCreditLogo from '../../../assets/icons/ford-credit-logo.png';
import './FormHeaderSection.scss';
import closeIcon from '../../../assets/icons/close-black.svg';
import {closeTier3ModalEvent, closeModal} from '../../../utils/tier-3-modal-close/PrequalCloseEvent';

export function FormHeaderSection({dispatch, customerData, className}) {
  function closeEvent() {
    if (!customerData.isDealerHostApplication.value) {
      closeModal(dispatch, customerData);
    } else {
      closeTier3ModalEvent({}, dispatch, customerData);
    }
  }

  return (
    <>
      <div data-testid='form-section-static-header-dealer-host' className='prequal--wc--static-form-section-header'>
        <div className={`prequal--wc--header-close-container ${className}`}>
          <div>
            <img src={FordCreditLogo} alt='Ford Credit Logo' className='prequal--wc--ford-credit-logo-dealer-host' />
          </div>
          <button onClick={closeEvent} type='button'>
            <img id='modal-close-icon' src={closeIcon} alt='close' />
          </button>
        </div>
      </div>
    </>
  );
}
